export interface RemoveReserveAndCollectionStatusUpdateRequest {
  id: number
  revision: number
}

export function RemoveReserveAndCollectionStatusUpdateRequestToJSON(
  value: RemoveReserveAndCollectionStatusUpdateRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
